import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import {Vue as VueIntegration} from '@sentry/integrations'

Vue.config.errorHandler = function (err) {
  // let componentName = formatComponentName(vm)
  // let propsData = vm.$options && vm.$options.propsData
  // Sentry.configureScope((scope) => {
  //   scope.setUser({ 'username': localStorage.getItem('user_nickname') })
  // })
  Sentry.captureException(err)
}

window.onload = function () {
  Sentry.init({
    dsn: 'https://8f440fc7027f414ebc8e1ab45b539c21@o270585.ingest.sentry.io/5235369',
    integrations: [new VueIntegration({Vue, attachProps: true, logErrors: true})],
    environment: process.env.NODE_ENV === 'development' ? 'development' : 'production',
    release: require('../latest-version').version
  })
  Sentry.configureScope((scope) => {
    scope.setUser({ 'username': localStorage.getItem('user_nickname') || 'unsave-name' })
  })
  window.Sentry = Sentry
}
